const API_BASE = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:3002/').replace(/\/?$/, '/');

function authHeaders() {
  const token = localStorage.getItem('token');
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

async function parse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || data.error || `HTTP ${res.status}`);
  }
  return data;
}

/** Login email-MFA flag on global.g_userlist (by gu_user_id). */
export async function fetchMfaStatus(guUserId) {
  const res = await fetch(`${API_BASE}synctrack/mfa/users/${guUserId}/status`, {
    headers: authHeaders(),
  });
  return parse(res);
}

export async function setMfaStatus(guUserId, mfaEnabled) {
  const res = await fetch(`${API_BASE}synctrack/mfa/users/${guUserId}/status`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify({ mfaEnabled: !!mfaEnabled }),
  });
  return parse(res);
}

export async function fetchMfaStatusByUsername(username) {
  const res = await fetch(
    `${API_BASE}synctrack/mfa/users/by-username/${encodeURIComponent(username)}/status`,
    { headers: authHeaders() }
  );
  return parse(res);
}

export async function setMfaStatusByUsername(username, mfaEnabled) {
  const res = await fetch(
    `${API_BASE}synctrack/mfa/users/by-username/${encodeURIComponent(username)}/status`,
    {
      method: 'PUT',
      headers: authHeaders(),
      body: JSON.stringify({ mfaEnabled: !!mfaEnabled }),
    }
  );
  return parse(res);
}
